export const APP_MOUNT = 'APP_MOUNT';
export const SET_APP_ENABLE_PAGE = 'SET_APP_ENABLE_PAGE';
export const SET_APP_PAGE = 'SET_APP_PAGE';
export const SET_ROOM_OPTION = 'SET_ROOM_OPTION';